import _extends from '@babel/runtime/helpers/esm/extends';
import React, { useState, useEffect } from 'react';
import { Box, Button, Input, Slider } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import Modal from '@mui/material/Modal';

const SlideShowContent = ({
  images,
  texts,
  onChange,
  index = 0,
  fullScreen = false,
  customRender,
  ...props
}) => {
  const [slideIndex, setSlideIndex] = useState(index);
  useEffect(() => {
    onChange && onChange(slideIndex);
  }, [slideIndex, onChange]);
  useEffect(() => {
    setSlideIndex(index);
  }, [index]);
  return /*#__PURE__*/React.createElement(Box, props, /*#__PURE__*/React.createElement(Box, {
    sx: {
      m: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      aspectRatio: '16/9'
    }
  }, customRender ? customRender({
    src: images[slideIndex],
    text: (texts == null ? void 0 : texts[slideIndex]) || '',
    index: slideIndex
  }) : /*#__PURE__*/React.createElement("img", {
    alt: `slide-${slideIndex}`,
    src: images[slideIndex],
    width: '100%',
    style: {
      border: '1px solid #eee'
    }
  }))), /*#__PURE__*/React.createElement(Box, {
    sx: {
      m: 0,
      py: 1,
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'background.paper'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => setSlideIndex(slideIndex - 1 < 0 ? 0 : slideIndex - 1),
    startIcon: /*#__PURE__*/React.createElement(ArrowBackIosNewIcon, {
      color: "primary"
    }),
    sx: {
      mr: 2
    }
  }, "prev"), /*#__PURE__*/React.createElement(Input, {
    sx: {
      width: 45,
      my: 'auto',
      mr: 2
    },
    value: slideIndex || '',
    onChange: e => {
      const value = parseInt(e.target.value);
      setSlideIndex(value > images.length - 1 ? images.length - 1 : value < 0 ? 0 : value);
    },
    inputProps: {
      step: 1,
      min: -1,
      max: images.length - 1,
      type: 'number',
      'aria-labelledby': 'input-slider'
    }
  }), /*#__PURE__*/React.createElement(Slider, {
    sx: {
      my: 'auto'
    },
    defaultValue: 0,
    min: 0,
    max: images.length - 1,
    valueLabelDisplay: "auto",
    value: slideIndex,
    onChange: e => {
      var _e$target;
      setSlideIndex(parseInt(e == null || (_e$target = e.target) == null ? void 0 : _e$target.value));
    }
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: () => setSlideIndex(slideIndex + 1 > images.length - 1 ? images.length - 1 : slideIndex + 1),
    endIcon: /*#__PURE__*/React.createElement(ArrowForwardIosIcon, {
      color: "primary"
    }),
    sx: {
      ml: 2
    }
  }, "next"), /*#__PURE__*/React.createElement(Button, {
    onClick: () => {
      props.onFullScreen && props.onFullScreen();
    }
  }, fullScreen ? /*#__PURE__*/React.createElement(FullscreenExitIcon, null) : /*#__PURE__*/React.createElement(FullscreenIcon, null))));
};
const SlideShow = ({
  sx,
  ...props
}) => {
  const [open, setOpen] = useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SlideShowContent, _extends({
    sx: {
      ...sx
    }
  }, props, {
    fullScreen: false,
    onFullScreen: () => setOpen(!open)
  })), /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: () => setOpen(!open),
    "aria-labelledby": "modal-modal-title",
    "aria-describedby": "modal-modal-description"
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      bgcolor: 'background.paper',
      width: 'min(calc(90vh * 15 / 9), 100vw)'
    }
  }, /*#__PURE__*/React.createElement(SlideShowContent, _extends({}, props, {
    fullScreen: open,
    onFullScreen: () => setOpen(!open)
  })))));
};

export { SlideShow, SlideShowContent };
